module.exports = __webpack_public_path__ + "static/media/bandHuntMobile.1af7d059.webp";